export default __webpack_public_path__ + "static/media/download.8c40e9bc.svg";